export const addEditKeyValidation = {
  keyNumber: [{ required: true, message: 'Key number is required!' }],
  name: [{ required: true, message: 'Key name is required!' }],
};
